export class FilterObject {
  constructor() {
    this.Key = "";
    this.Value = "";
    this.Operand = "";
  }

  public Key: string;
  public Value: string;
  public Operand: string;
}
